﻿(function() {
    "use strict";

    angular
        .module("app")
        .controller("ForgotAccountController", ForgotAccountController);

    ForgotAccountController.$inject = []

    function ForgotAccountController() {
    }

})();
